<template>
  <div class="common_module page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary"
          @click="dialogVisable=true,moduleDialogTitle='新增模块信息'">新增
        </el-button>
      </div>
      <div class="page-panel-header__title">公共组件模块</div>
    </div>
    <div class="page-panel__body">
      <el-form class="page-panel-search-form" :inline="true">
        <div class="page-panel-search-bread">
          <span v-for="item in options" :key="item.value" :class="{isactive:item.value==searchModel.commonType}"
            @click="getModuleListByTypeId(item.value)">{{item.label}}</span>
        </div>
      </el-form>
      <el-table border stripe :data="moduleList">
        <el-table-column label="序号" type="index" width="60" align="center">
        </el-table-column>
        <el-table-column label="所属模块" prop="commonName" align="center">
        </el-table-column>
        <el-table-column label="顺序" align="center" prop="commonRanking" width="60">
        </el-table-column>
        <el-table-column label="标题" align="center" prop="commonName">
        </el-table-column>
        <el-table-column label="图片地址" align="center" width="110">
          <template slot-scope="scope">
            <img :src="scope.row.commonImg?scope.row.commonImg:'/static/img/common/zwtp.png'" class="table_image"
              onerror="this.src='/static/img/common/zwtp.png'">
          </template>
        </el-table-column>
        <el-table-column label="简介" align="center" :show-overflow-tooltip=true>
          <template slot-scope="scope">
            <p v-html='scope.row.commonText'>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="链接地址" align="center" width="100">
        </el-table-column>
        <el-table-column label="录入时间" align="center" width="100">
        </el-table-column>
        <el-table-column label="录入人" align="center" width="80">
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editModule(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteModule(scope.row.commonId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-panel__footer">
        <el-pagination :page-size='searchModel.pageSize' layout='prev, pager, next, jumper' :total='total'
          :close-on-click-modal="false" :current-page.sync='searchModel.pageNo'>
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="moduleDialogTitle" :visible.sync="dialogVisable" width="55%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th><span class="required_column">*</span>标题名称</th>
            <td>
              <el-input placeholder="请输入标题名称" v-model="modulePram.commonName"></el-input>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>所属模块</th>
            <td>
              <el-select v-model="modulePram.commonType" placeholder="请选择所属模块">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <th>图片地址</th>
            <td>
              <el-upload class="avatar-uploader" action="/file/upload" :show-file-list="false"
                :on-success="uploadSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th>顺序</th>
            <td>
              <el-input placeholder="请输入展示顺序" v-model="modulePram.commonRanking" type="number"></el-input>
            </td>
          </tr>
          <tr>
            <th>链接地址</th>
            <td>
              <el-input placeholder="请输入链接地址" v-model="modulePram.commonUrl"></el-input>
            </td>
          </tr>
          <tr>
            <th>内容简介</th>
            <td>
              <ueditor :config="editorConfig" v-model="modulePram.commonText"></ueditor>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisable= false">取消</el-button>
        <el-button type="primary" @click="addModule">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
/**
 * 接口：getModuleListByTypeId
 * 参数：typeId （0:全部/1:banner/2:联盟章程/3:友情链接/4:政府支持/5:联系我们/6:URL二维码/7:联盟简介）
 */
import * as moduleApi from '@/api/module';
export default {
  data() {
    return {
      moduleDialogTitle: '新增模块信息',
      imageUrl: '',
      modulePram: {},
      dialogVisable: false,
      selectValue: 1,
      total: 0,
      moduleList: [],
      searchModel: {
        pageNo: 1,
        pageSize: 10,
        commonType: 1
      },
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      },
      options: [
        {
          value: 1,
          label: '首页banner'
        },
        {
          value: 2,
          label: '首页联盟章程'
        },
        {
          value: 3,
          label: '友情链接'
        },
        {
          value: 4,
          label: '政府支持'
        },
        {
          value: 5,
          label: '联系我们'
        },
        {
          value: 6,
          label: '二维码'
        },
        {
          value: 7,
          label: '首页联盟简介（短）'
        },
        {
          value: 8,
          label: '首页联盟简介（长）'
        },
        {
          value: 9,
          label: '联盟章程（长）'
        }
      ]
    };
  },
  methods: {
    checkInfo(info) {
      var urlRule = /(http|https):\/\/([\w.]+\/?)\S*/;
      if (!info.commonName) {
        this.$notify({
          title: '警告',
          message: '请输入标题名称',
          type: 'warning'
        });
        return false;
      } else if (info.commonName.length > 30) {
        this.$notify({
          title: '警告',
          message: '标题字数不能超过30',
          type: 'warning'
        });
        return false;
      } else if (!info.commonType) {
        this.$notify({
          title: '警告',
          message: '请选择所属模块',
          type: 'warning'
        });
        return false;
      } else if (info.commonUrl && !urlRule.test(info.commonUrl)) {
        this.$notify({
          title: '警告',
          message: '无效链接地址',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    editModule(row) {
      this.moduleDialogTitle = '编辑模块信息';
      this.modulePram = JSON.parse(JSON.stringify(row));
      this.imageUrl = this.modulePram.commonImg;
      this.dialogVisable = true;
    },
    deleteModule(id) {
      this.$confirm('是否删除该模块信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          moduleApi.deleteModule({ commonId: id }).then(res => {
            this.getModuleListByTypeId(this.searchModel.commonType);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    addModule() {
      if (this.checkInfo(this.modulePram)) {
        if (this.modulePram.commonId) {
          moduleApi.updateModule(this.modulePram).then(res => {
            this.init();
          });
        } else {
          moduleApi.addModule(this.modulePram).then(res => {
            this.init();
          });
        }
      }
    },
    init() {
      this.getModuleListByTypeId(this.modulePram.commonType);
      this.modulePram = {};
      this.dialogVisable = false;
    },
    uploadSuccess(res, file, fileList) {
      this.modulePram.commonImg = res.url;
      this.imageUrl = res.url;
    },
    getModuleListByTypeId(val) {
      this.searchModel.commonType = val;
      moduleApi
        .getModuleListByTypeId({
          ...this.searchModel
        })
        .then(res => {
          if (res.data) {
            this.moduleList = res.data.records;
          }
        });
    }
  },
  created() {
    this.getModuleListByTypeId(1);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/commonModule/index.vue